import { render, staticRenderFns } from "./zingala-payment.vue?vue&type=template&id=56fa49c2"
import script from "./zingala-payment.vue?vue&type=script&lang=js"
export * from "./zingala-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports